import { render, staticRenderFns } from "./OilTreatmentNoteModal.vue?vue&type=template&id=5d4fae20"
import script from "./OilTreatmentNoteModal.vue?vue&type=script&lang=js"
export * from "./OilTreatmentNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports